import React from 'react'

const Footer = () => {
  return (
     <footer className="bg-gray-100 p-4 text-center text-gray-500 w-full  ">
         Designed By <span className='text-blue-500'>DCE Technology</span>
    
    </footer>
  )
}

export default Footer;